<template>
	<v-navigation-drawer
		v-model="drawer"
		app
		:mini-variant="mini"
		permanent
		color="lightest"
		style="z-index: 100"
	>
		<logged-in v-if="loggedIn"></logged-in>
		<login v-else></login>
		<v-divider></v-divider>

		<v-list dense>
			<nav-item
				v-for="item in displayItems"
				:key="item.title"
				:link="item.link"
				v-bind="item"
			>
			</nav-item>
		</v-list>
		<template v-slot:append>
			<v-list dense>
				<logout v-if="loggedIn"></logout>
				<nav-item
					@click="mini = !mini"
					:text="$t('buttons.collapse')"
					:icon="mini ? 'mdi-chevron-right' : 'mdi-chevron-left'"
				></nav-item>
			</v-list>
		</template>
	</v-navigation-drawer>
</template>
<script>
import LoggedIn from "@/components/auth/LoggedIn";
import Login from "@/components/auth/Login";
import Logout from "@/components/auth/Logout.vue";
import NavItem from "@/components/navigation/Item";
export default {
	name: "Sidebar",
	computed: {
		loggedIn() {
			return this.$store.state.auth.logged_in;
		},
		displayItems() {
			var loggedIn = this.loggedIn;
			return this.items.filter((a) => {
				return !a.loggedIn || loggedIn;
			});
		},
		items() {
			return [
				{ text: "Home", icon: "mdi-home", link: "/" },
				{
					text: "Checklist",
					loggedIn: true,
					icon: "mdi-clipboard-check",
					link: "/checklist",
				},
				{
					text: this.$store.state.users.name.plural,
					icon: this.$store.state.users.icon,
					link: this.$store.state.users.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.surveys.name.plural,
					icon: this.$store.state.surveys.icon,
					link: this.$store.state.surveys.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.projects.name.plural,
					icon: this.$store.state.projects.icon,
					link: this.$store.state.projects.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.organisations.name.plural,
					icon: this.$store.state.organisations.icon,
					link: this.$store.state.organisations.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.profileFields.name.plural,
					icon: this.$store.state.profileFields.icon,
					link: this.$store.state.profileFields.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.incentives.name.plural,
					icon: this.$store.state.incentives.icon,
					link: this.$store.state.incentives.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.templates.name.plural,
					icon: this.$store.state.templates.icon,
					link: this.$store.state.templates.path,
					loggedIn: true,
				},
				{
					text: this.$store.state.content.name.plural,
					icon: this.$store.state.content.icon,
					link: this.$store.state.content.path,
					loggedIn: true,
				},
			];
		},
	},
	data() {
		return {
			drawer: true,
			mini: true,
		};
	},
	components: {
		Login,
		LoggedIn,
		Logout,
		NavItem,
	},
};
</script>
